import { BillableActionError } from "../../util/errors.ts";
import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";

export type VendorDiscoveryLocation = {
    vendorAddressUniqueKey: string;
    street1: string;
    street2: string | null;
    city: string;
    state: string;
    fullStateName: string;
    zipcode: string;
    latitude: number;
    longitude: number;
};

export interface Vendor {
    accountNumber?: number;
    addressCity?: string;
    addressState?: string;
    addressStreet?: string;
    addressZip?: string;
    createdAt: string;
    deletedAt?: string;
    id: number;
    name: string;
    phoneNumber?: string;
    poEmail: string;
    refNumber?: string;
    salesRepEmail?: string;
    salesRepName?: string;
    salesRepPhoneNumber?: string;
    teamId: number;
    url: string;
    vendorData?: VendorData;
}

type VendorData = {
    brandsCarried: string[];
    certifications: string[];
    isDistributor: boolean;
    isManufacturer: boolean;
    isServiceProvider: boolean;
    name: string;
    overview: string;
    productCategories: string[];
    productTypes: string[];
    services: string[];
    addresses: string[];
    emailAddress: string;
    operatingHours: string;
    phoneNumber: string;
    domain: string;
    id: string;
    _rid: string;
    _self: string;
    _etag: string;
    _attachments: string;
    _ts: number;
};

export default {
    getVendorDiscovery: (): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/vendor/discovery/history`, {
            headers: getHeaders(),
        }).then(res => res.json()),

    searchVendorDiscovery: (body: { vendorDiscoveryId?: string; queryString: string; limit: number; offset: number }): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/vendor/discovery`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify(body),
        }).then(res => {
            if (res.status > 299) {
                return Promise.reject(Error(`Request failed with statusCode ${res.status}`));
            }
            return res.json();
        }),

    unmaskDiscoveryVendor: (uniqueVendorId: string): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/vendor/discovery/unmask`, {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify({ uniqueVendorId }),
        }).then(res => {
            // They didn't have enough credits
            if (res.status === 402) {
                return Promise.reject(new BillableActionError());
            }

            // General error happened
            if (res.status > 299) {
                return Promise.reject(Error(`Request failed with statusCode ${res.status}`));
            }

            return res.json();
        }),

    getDiscoveryVendor: (vendorId: string): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/vendor/discovery/${vendorId}`, {
            headers: getHeaders(),
        }).then(res => res.json()),

    getDiscoveryVendorLocations: (vendorId: string | number | undefined): Promise<VendorDiscoveryLocation[]> =>
        fetch(`${PURCHASER_API_BASE_URL}/vendor/discovery/${vendorId}/locations`, {
            headers: getHeaders(),
        }).then(res => res.json()),

    deleteVendorDiscoverySearch: (vendorDiscoveryId: string): Promise<any> =>
        fetch(`${PURCHASER_API_BASE_URL}/vendor/discovery/search/${vendorDiscoveryId}`, {
            method: "DELETE",
            headers: getHeaders(),
            body: JSON.stringify({}),
        }).then(res => res.json()),
};
